import { ComponentTypeID } from './component-ids';
import { TABS_VARIANTS, TABS_ORIENTATIONS, TABS_ACTIVATION_MODES, ACCORDION_SIZES, ACCORDION_VARIANTS, ALERT_VARIANTS, BREADCRUMB_SIZES, BREADCRUMB_VARIANTS, BUTTON_GROUP_ORIENTATIONS, BUTTON_ICONS, BUTTON_SIZES, BUTTON_SPINNER_PLACEMENTS, BUTTON_VARIANTS, CHECKBOX_LABEL_POSITIONS, CHECKBOX_VARIANTS, CHART_KINDS, COMPOSER_SUBMIT_MODES, COMPOSER_STATUSES, CODE_RECIPE_COLORS, CODE_SIZES, CODE_VARIANTS, CONTROL_SIZES, DIVIDER_ORIENTATIONS, DIVIDER_VARIANTS, DROPDOWN_MENU_ALIGNS, DROPDOWN_MENU_PLACEMENTS, DROPDOWN_MENU_POSITION_STRATEGIES, FIELD_INDICATORS, FOCUS_RING_PLACEMENTS, FLYOUT_ITEM_STATES, FLYOUT_PLACEMENTS, FONT_WEIGHTS, FORM_ORIENTATIONS, HEADING_LEVELS, INPUT_TYPES, INPUT_VARIANTS, LAYOUT_ALIGNMENTS, LINK_UNDERLINES, MESSAGE_PAIR_USER_VARIANTS, TOOL_CALL_STATES, MODAL_PLACEMENTS, MODAL_ROLES, MODAL_SCROLL_BEHAVIORS, MODAL_SIZES, NAV_TREE_MAX_LEVEL, SCROLL_AREA_GUTTERS, SCROLL_AREA_ORIENTATIONS, SCROLL_AREA_SCROLLBARS, SCROLL_AREA_SIZES, SCROLL_AREA_VARIANTS, SEGMENTED_CONTROL_ITEM_CONTENTS, SEGMENTED_CONTROL_LAYOUTS, SEGMENTED_CONTROL_VARIANTS, SELECT_VARIANTS, SPINNER_SIZES, STREAMING_TEXT_SEGMENT_KINDS, STREAMING_TEXT_STATUSES, STACK_DIRECTIONS, STACK_JUSTIFICATIONS, TABLE_CAPTION_SIDES, TABLE_HEADER_SCOPES, TABLE_LAYOUTS, TABLE_SIZES, TABLE_STICKY_POSITIONS, TABLE_VARIANTS, TEXT_ALIGNMENTS, TEXT_RECIPE_COLORS, TEXT_RECIPE_WEIGHTS, TEXT_SIZES, TEXTAREA_RESIZES, TOAST_ICON_STYLES, TOAST_POSITIONS, TOAST_STATUSES, } from './component-vocabulary';
import { TABS_RECIPE_VARIANTS, ACCORDION_EMPTY_RECIPE_VARIANTS, ACCORDION_RECIPE_VARIANTS, ALERT_RECIPE_VARIANTS, BREADCRUMB_RECIPE_VARIANTS, BUTTON_GROUP_RECIPE_VARIANTS, BUTTON_RECIPE_VARIANTS, CHART_RECIPE_VARIANTS, CHECKBOX_GROUP_RECIPE_VARIANTS, CHECKBOX_RECIPE_VARIANTS, COMPOSER_RECIPE_VARIANTS, CODE_BLOCK_RECIPE_VARIANTS, CODE_RECIPE_VARIANTS, DIVIDER_RECIPE_VARIANTS, DROPDOWN_MENU_CONTENT_RECIPE_VARIANTS, DROPDOWN_MENU_EMPTY_RECIPE_VARIANTS, DROPDOWN_MENU_ITEM_RECIPE_VARIANTS, DROPDOWN_MENU_LABEL_RECIPE_VARIANTS, DROPDOWN_MENU_RECIPE_VARIANTS, DROPDOWN_MENU_TRIGGER_RECIPE_VARIANTS, EMPTY_RECIPE_VARIANTS, FIELD_ERROR_RECIPE_VARIANTS, FIELD_GROUP_RECIPE_VARIANTS, FIELD_LABEL_RECIPE_VARIANTS, FIELD_RECIPE_VARIANTS, FIELD_SET_RECIPE_VARIANTS, FLYOUT_ITEM_RECIPE_VARIANTS, FLYOUT_RECIPE_VARIANTS, INPUT_RECIPE_VARIANTS, LABEL_RECIPE_VARIANTS, LINK_RECIPE_VARIANTS, MESSAGE_PAIR_RECIPE_VARIANTS, TOOL_CALL_RECIPE_VARIANTS, MODAL_CONTENT_RECIPE_VARIANTS, MODAL_EMPTY_RECIPE_VARIANTS, MODAL_POSITIONER_RECIPE_VARIANTS, NAV_TREE_RECIPE_VARIANTS, PROGRESS_RECIPE_VARIANTS, RADIO_GROUP_RECIPE_VARIANTS, RADIO_RECIPE_VARIANTS, SCROLL_AREA_RECIPE_VARIANTS, SEGMENTED_CONTROL_RECIPE_VARIANTS, SELECT_RECIPE_VARIANTS, SPINNER_RECIPE_VARIANTS, STACK_RECIPE_VARIANTS, STREAMING_TEXT_RECIPE_VARIANTS, SWITCH_RECIPE_VARIANTS, TABLE_CAPTION_RECIPE_VARIANTS, TABLE_EMPTY_RECIPE_VARIANTS, TABLE_RECIPE_VARIANTS, TABLE_SCROLL_AREA_RECIPE_VARIANTS, TEXT_RECIPE_VARIANTS, TEXTAREA_RECIPE_VARIANTS, TOAST_RECIPE_VARIANTS, TOASTER_RECIPE_VARIANTS, } from './component-recipe-variants';
import { arrayProp, boolProp, borderProp, borderStyleProp, borderWidthProp, breakpointProp, colorTokenProp, contentProp, enumProp, numberProp, objectProp, propsRecord, radiusTokenProp, shadowTokenProp, sizeTokenProp, spacingProp, stringOrNumberProp, stringOrStringArrayProp, stringProp, zIndexTokenProp, } from './schema-prop-builders';
import { contentSlot, dataSlot, normalizeSlotDefinitions, slotsRecord, textSlot } from './schema-slot-builders';
import { isUtilityPropName } from './utility-prop-names';
function compareStrings(left, right) {
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
}
const GROUPED_SPACING_AXIS_PROPERTIES = propsRecord({
    x: spacingProp({ description: 'Horizontal spacing (number or explicit CSS value)' }),
    y: spacingProp({ description: 'Vertical spacing (number or explicit CSS value)' }),
});
const AXIS_SPACING_UTILITY_PROPERTIES = propsRecord({
    paddingX: spacingProp({ description: 'Horizontal padding (numeric spacing step)' }),
    paddingY: spacingProp({ description: 'Vertical padding (numeric spacing step)' }),
    paddingTop: spacingProp({ description: 'Top padding (numeric spacing step)' }),
    paddingRight: spacingProp({ description: 'Right padding (numeric spacing step)' }),
    paddingBottom: spacingProp({ description: 'Bottom padding (numeric spacing step)' }),
    paddingLeft: spacingProp({ description: 'Left padding (numeric spacing step)' }),
    paddingStart: spacingProp({ description: 'Logical inline-start padding (numeric spacing step)' }),
    paddingEnd: spacingProp({ description: 'Logical inline-end padding (numeric spacing step)' }),
    marginX: spacingProp({ description: 'Horizontal margin (number or explicit CSS value)' }),
    marginY: spacingProp({ description: 'Vertical margin (number or explicit CSS value)' }),
    marginTop: spacingProp({ description: 'Top margin (number or explicit CSS value)' }),
    marginRight: spacingProp({ description: 'Right margin (number or explicit CSS value)' }),
    marginBottom: spacingProp({ description: 'Bottom margin (number or explicit CSS value)' }),
    marginLeft: spacingProp({ description: 'Left margin (number or explicit CSS value)' }),
    marginStart: spacingProp({ description: 'Logical inline-start margin (number or explicit CSS value)' }),
    marginEnd: spacingProp({ description: 'Logical inline-end margin (number or explicit CSS value)' }),
    spaceX: spacingProp({ description: 'Horizontal spacing between children (numeric spacing step)' }),
    spaceY: spacingProp({ description: 'Vertical spacing between children (numeric spacing step)' }),
    translateX: spacingProp({ description: 'Horizontal translate offset (numeric spacing step)' }),
    translateY: spacingProp({ description: 'Vertical translate offset (numeric spacing step)' }),
});
const DIMENSION_UTILITY_PROPERTIES = propsRecord({
    width: sizeTokenProp({ description: 'Width (size token, number, or explicit CSS value)' }),
    height: sizeTokenProp({ description: 'Height (size token, number, or explicit CSS value)' }),
    minWidth: sizeTokenProp({ description: 'Minimum width (size token, number, or explicit CSS value)' }),
    maxWidth: sizeTokenProp({ description: 'Maximum width (size token, number, or explicit CSS value)' }),
    minHeight: sizeTokenProp({ description: 'Minimum height (size token, number, or explicit CSS value)' }),
    maxHeight: sizeTokenProp({ description: 'Maximum height (size token, number, or explicit CSS value)' }),
});
const VISIBILITY_UTILITY_PROPERTIES = propsRecord({
    hideFrom: breakpointProp({ description: 'Hide this element from the given breakpoint and above' }),
    hideBelow: breakpointProp({ description: 'Hide this element below the given breakpoint' }),
});
// hideFrom and hideBelow accept a single breakpoint key — responsive wrapping is nonsensical.
const VISIBILITY_PROP_GUARDRAILS = Object.freeze({
    hideFrom: Object.freeze({ scanner: Object.freeze({ responsiveSupport: 'unsupported' }) }),
    hideBelow: Object.freeze({ scanner: Object.freeze({ responsiveSupport: 'unsupported' }) }),
});
const DISPLAY_UTILITY_PROPERTY = propsRecord({
    display: stringProp({ description: 'Display mode keyword (for example block, none, flex, inline-flex)' }),
    ...VISIBILITY_UTILITY_PROPERTIES,
});
const BOX_MODEL_UTILITY_PROPERTIES = propsRecord({
    boxSizing: stringProp({ description: 'CSS box-sizing value' }),
});
const TEXT_STYLE_UTILITY_PROPERTY = propsRecord({
    textStyle: stringProp({ description: 'Semantic text style name from theme.textStyles' }),
});
const COLOR_DECORATION_UTILITY_PROPERTIES = propsRecord({
    background: colorTokenProp({ description: 'Background color (token or raw color)' }),
    backgroundColor: colorTokenProp({ description: 'Background color alias (token or raw color)' }),
    color: colorTokenProp({ description: 'Foreground color (token or raw color)' }),
    outlineColor: colorTokenProp({ description: 'Outline color (token or raw color)' }),
});
const EFFECT_UTILITY_PROPERTIES = propsRecord({
    boxShadow: shadowTokenProp({ description: 'Box shadow (token or explicit CSS shadow value)' }),
});
const LAYER_UTILITY_PROPERTIES = propsRecord({
    zIndex: zIndexTokenProp({ description: 'Stacking order (token, integer, or explicit CSS value)' }),
});
const CURSOR_UTILITY_PROPERTY = propsRecord({
    cursor: stringProp({ description: 'CSS cursor keyword or value' }),
});
const BORDER_COMBINED_UTILITY_PROPERTIES = propsRecord({
    border: borderProp({ description: 'Border shorthand (border token or explicit CSS border value)' }),
    borderTop: borderProp({ description: 'Top border shorthand' }),
    borderBottom: borderProp({ description: 'Bottom border shorthand' }),
    borderLeft: borderProp({ description: 'Left border shorthand' }),
    borderRight: borderProp({ description: 'Right border shorthand' }),
    borderStart: borderProp({ description: 'Logical inline-start border shorthand' }),
    borderEnd: borderProp({ description: 'Logical inline-end border shorthand' }),
    borderX: borderProp({ description: 'Logical inline border shorthand' }),
    borderY: borderProp({ description: 'Logical block border shorthand' }),
});
const BORDER_COLOR_UTILITY_PROPERTIES = propsRecord({
    borderColor: colorTokenProp({ description: 'Border color (token or raw color)' }),
    borderTopColor: colorTokenProp({ description: 'Top border color (token or raw color)' }),
    borderBottomColor: colorTokenProp({ description: 'Bottom border color (token or raw color)' }),
    borderLeftColor: colorTokenProp({ description: 'Left border color (token or raw color)' }),
    borderRightColor: colorTokenProp({ description: 'Right border color (token or raw color)' }),
    borderStartColor: colorTokenProp({ description: 'Logical inline-start border color (token or raw color)' }),
    borderEndColor: colorTokenProp({ description: 'Logical inline-end border color (token or raw color)' }),
    borderXColor: colorTokenProp({ description: 'Logical inline border color (token or raw color)' }),
    borderYColor: colorTokenProp({ description: 'Logical block border color (token or raw color)' }),
});
const BORDER_STYLE_UTILITY_PROPERTIES = propsRecord({
    borderStyle: borderStyleProp({ description: 'Border style (token or explicit CSS value)' }),
    borderTopStyle: borderStyleProp({ description: 'Top border style' }),
    borderBottomStyle: borderStyleProp({ description: 'Bottom border style' }),
    borderLeftStyle: borderStyleProp({ description: 'Left border style' }),
    borderRightStyle: borderStyleProp({ description: 'Right border style' }),
    borderStartStyle: borderStyleProp({ description: 'Logical inline-start border style' }),
    borderEndStyle: borderStyleProp({ description: 'Logical inline-end border style' }),
});
const BORDER_WIDTH_UTILITY_PROPERTIES = propsRecord({
    borderWidth: borderWidthProp({ description: 'Border width (token, number, or explicit CSS value)' }),
    borderTopWidth: borderWidthProp({ description: 'Top border width' }),
    borderBottomWidth: borderWidthProp({ description: 'Bottom border width' }),
    borderLeftWidth: borderWidthProp({ description: 'Left border width' }),
    borderRightWidth: borderWidthProp({ description: 'Right border width' }),
    borderStartWidth: borderWidthProp({ description: 'Logical inline-start border width' }),
    borderEndWidth: borderWidthProp({ description: 'Logical inline-end border width' }),
    borderXWidth: borderWidthProp({ description: 'Logical inline border width' }),
    borderYWidth: borderWidthProp({ description: 'Logical block border width' }),
});
const BORDER_UTILITY_PROPERTIES = propsRecord({
    ...BORDER_COMBINED_UTILITY_PROPERTIES,
    ...BORDER_COLOR_UTILITY_PROPERTIES,
    ...BORDER_STYLE_UTILITY_PROPERTIES,
    ...BORDER_WIDTH_UTILITY_PROPERTIES,
});
const DIVIDE_UTILITY_PROPERTIES = propsRecord({
    divideX: borderWidthProp({ description: 'Inline divider width between sibling children' }),
    divideY: borderWidthProp({ description: 'Block divider width between sibling children' }),
    divideColor: colorTokenProp({ description: 'Divider color between sibling children (token or raw color)' }),
    divideStyle: borderStyleProp({ description: 'Divider border style between sibling children' }),
});
const RADIUS_UTILITY_PROPERTIES = propsRecord({
    borderRadius: radiusTokenProp({ description: 'Border radius (token or explicit CSS value)' }),
    borderTopLeftRadius: radiusTokenProp({ description: 'Top-left border radius' }),
    borderTopRightRadius: radiusTokenProp({ description: 'Top-right border radius' }),
    borderBottomLeftRadius: radiusTokenProp({ description: 'Bottom-left border radius' }),
    borderBottomRightRadius: radiusTokenProp({ description: 'Bottom-right border radius' }),
    borderStartStartRadius: radiusTokenProp({ description: 'Logical start-start border radius' }),
    borderStartEndRadius: radiusTokenProp({ description: 'Logical start-end border radius' }),
    borderEndStartRadius: radiusTokenProp({ description: 'Logical end-start border radius' }),
    borderEndEndRadius: radiusTokenProp({ description: 'Logical end-end border radius' }),
    borderInlineStartRadius: radiusTokenProp({ description: 'Logical inline-start border radius' }),
    borderInlineEndRadius: radiusTokenProp({ description: 'Logical inline-end border radius' }),
    borderTopRadius: radiusTokenProp({ description: 'Top-side border radius' }),
    borderBottomRadius: radiusTokenProp({ description: 'Bottom-side border radius' }),
    borderLeftRadius: radiusTokenProp({ description: 'Left-side border radius' }),
    borderRightRadius: radiusTokenProp({ description: 'Right-side border radius' }),
});
const FLEX_SIZE_UTILITY_PROPERTIES = propsRecord({
    basis: sizeTokenProp({ description: 'Flex basis (size token, number, or explicit CSS value)' }),
    grow: numberProp({ description: 'Flex grow factor' }),
    shrink: numberProp({ description: 'Flex shrink factor' }),
});
const FLEX_ITEM_ALIGNMENT_UTILITY_PROPERTIES = propsRecord({
    alignSelf: stringProp({ description: 'Explicit align-self value for the flex item' }),
    justifySelf: stringProp({ description: 'Explicit justify-self value for the flex item' }),
});
const CONTAINER_PADDING_UTILITY_PROPERTY = propsRecord({
    padding: spacingProp({
        description: 'Inner padding (numeric spacing step or axis-specific object)',
        properties: GROUPED_SPACING_AXIS_PROPERTIES,
    }),
});
const CONTAINER_MARGIN_UTILITY_PROPERTY = propsRecord({
    margin: spacingProp({
        description: 'Outer margin (number, explicit CSS value, or axis-specific object)',
        properties: GROUPED_SPACING_AXIS_PROPERTIES,
    }),
});
const MARGIN_UTILITY_PROPERTIES = propsRecord({
    ...CONTAINER_MARGIN_UTILITY_PROPERTY,
    marginX: spacingProp({ description: 'Horizontal margin (number or explicit CSS value)' }),
    marginY: spacingProp({ description: 'Vertical margin (number or explicit CSS value)' }),
    marginTop: spacingProp({ description: 'Top margin (number or explicit CSS value)' }),
    marginRight: spacingProp({ description: 'Right margin (number or explicit CSS value)' }),
    marginBottom: spacingProp({ description: 'Bottom margin (number or explicit CSS value)' }),
    marginLeft: spacingProp({ description: 'Left margin (number or explicit CSS value)' }),
    marginStart: spacingProp({ description: 'Logical inline-start margin (number or explicit CSS value)' }),
    marginEnd: spacingProp({ description: 'Logical inline-end margin (number or explicit CSS value)' }),
});
function buildContainerSurfaceUtilityProperties(options = {}) {
    return propsRecord({
        ...DIMENSION_UTILITY_PROPERTIES,
        ...CONTAINER_PADDING_UTILITY_PROPERTY,
        ...AXIS_SPACING_UTILITY_PROPERTIES,
        ...CONTAINER_MARGIN_UTILITY_PROPERTY,
        ...BOX_MODEL_UTILITY_PROPERTIES,
        ...COLOR_DECORATION_UTILITY_PROPERTIES,
        ...EFFECT_UTILITY_PROPERTIES,
        ...BORDER_UTILITY_PROPERTIES,
        ...(options.includeDivide ? DIVIDE_UTILITY_PROPERTIES : {}),
        ...RADIUS_UTILITY_PROPERTIES,
        ...LAYER_UTILITY_PROPERTIES,
        ...(options.includeFlexSize ? FLEX_SIZE_UTILITY_PROPERTIES : {}),
    });
}
const DIVIDED_CONTAINER_SURFACE_UTILITY_PROPERTIES = buildContainerSurfaceUtilityProperties({
    includeDivide: true,
});
const FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES = buildContainerSurfaceUtilityProperties({
    includeFlexSize: true,
});
const DIVIDED_FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES = buildContainerSurfaceUtilityProperties({
    includeDivide: true,
    includeFlexSize: true,
});
function stylingDriverForSupport(support) {
    switch (support) {
        case 'recipe-backed':
            return 'recipe';
        case 'utility-only':
            return 'utility';
        default:
            return 'none';
    }
}
function isResponsiveProp(input, propName) {
    const explicitResponsiveSupport = input.propGuardrails?.[propName]?.scanner?.responsiveSupport;
    if (explicitResponsiveSupport === 'supported') {
        return true;
    }
    if (explicitResponsiveSupport === 'unsupported') {
        return false;
    }
    if (input.propGuardrails?.[propName]?.scanner?.variantProjection) {
        return true;
    }
    if (isUtilityPropName(propName)) {
        return input.styling.support !== 'unsupported';
    }
    if (input.styling.support === 'utility-only') {
        return false;
    }
    if (input.styling.support === 'recipe-backed') {
        return Object.prototype.hasOwnProperty.call(input.styling.recipe?.variants ?? {}, propName);
    }
    return false;
}
function annotateResponsiveProps(input) {
    return Object.freeze(Object.fromEntries(Object.entries(input.schema.props).map(([propName, propDefinition]) => [
        propName,
        Object.freeze({
            ...propDefinition,
            responsive: isResponsiveProp(input, propName),
        }),
    ])));
}
function defineBuiltInComponentEntry(input) {
    if (input.styling.support === 'recipe-backed' && !input.styling.recipe) {
        throw new Error('[smoothie/ui-core] recipe-backed components must declare a recipe binding');
    }
    return Object.freeze({
        schema: Object.freeze({
            ...input.schema,
            props: annotateResponsiveProps(input),
            ...(input.schema.events && { events: Object.freeze([...input.schema.events]) }),
            ...(input.schema.slots && { slots: normalizeSlotDefinitions(input.schema.slots) }),
            ...(input.schema.elements && { elements: Object.freeze([...input.schema.elements]) }),
        }),
        styling: Object.freeze({
            driver: stylingDriverForSupport(input.styling.support),
            support: input.styling.support,
            ...(input.styling.recipe && {
                recipe: Object.freeze({
                    name: input.styling.recipe.name,
                    variants: input.styling.recipe.variants,
                }),
            }),
        }),
        ...(input.propGuardrails && {
            propGuardrails: Object.freeze(Object.fromEntries(Object.entries(input.propGuardrails).map(([propName, guardrail]) => [
                propName,
                Object.freeze({
                    ...(guardrail.scanner && {
                        scanner: Object.freeze({
                            ...guardrail.scanner,
                            ...(guardrail.scanner.variantProjection && {
                                variantProjection: Object.freeze({
                                    ...(guardrail.scanner.variantProjection.component && {
                                        component: guardrail.scanner.variantProjection.component,
                                    }),
                                    axis: guardrail.scanner.variantProjection.axis,
                                    valuesByInput: Object.freeze({
                                        ...guardrail.scanner.variantProjection.valuesByInput,
                                    }),
                                }),
                            }),
                        }),
                    }),
                }),
            ]))),
        }),
    });
}
function defineBuiltInComponentRegistry(registry) {
    const entries = Object.entries(registry).map(([componentId, entry]) => [
        componentId,
        defineBuiltInComponentEntry(entry),
    ]);
    return Object.freeze(Object.fromEntries(entries));
}
export const BUILT_IN_COMPONENT_REGISTRY = defineBuiltInComponentRegistry({
    Alert: {
        schema: {
            typeId: ComponentTypeID.Alert,
            description: 'Alert message',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                variant: enumProp(ALERT_VARIANTS, { default: 'info' }),
                title: stringProp(),
                dismissible: boolProp(false),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                title: textSlot({ multiple: true }),
            }),
            elements: ['title', 'dismiss'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'alert',
                variants: ALERT_RECIPE_VARIANTS,
            },
        },
    },
    Toast: {
        schema: {
            typeId: ComponentTypeID.Toast,
            description: 'Temporary feedback message',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                status: enumProp(TOAST_STATUSES, { default: 'default' }),
                iconStyle: enumProp(TOAST_ICON_STYLES, { default: 'outline' }),
                title: stringProp(),
                description: stringProp(),
                actionLabel: stringProp(),
                closable: boolProp(false),
                duration: stringOrNumberProp(),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                title: textSlot({ multiple: true }),
                description: textSlot({ multiple: true }),
                action: contentSlot({ multiple: true }),
            }),
            elements: ['icon', 'content', 'title', 'description', 'action', 'close'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'toast',
                variants: TOAST_RECIPE_VARIANTS,
            },
        },
    },
    Toaster: {
        schema: {
            typeId: ComponentTypeID.Toaster,
            description: 'Toast viewport',
            props: propsRecord({
                position: enumProp(TOAST_POSITIONS, { default: 'top-center' }),
                max: numberProp({ default: 3 }),
                duration: stringOrNumberProp(),
                offset: stringOrNumberProp(),
                pauseOnPageIdle: boolProp(true),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            elements: ['viewport'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'toaster',
                variants: TOASTER_RECIPE_VARIANTS,
            },
        },
    },
    Box: {
        schema: {
            typeId: ComponentTypeID.Box,
            description: 'Generic container',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                ...DIVIDED_FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
            }),
            slots: ['children'],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'box',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    Button: {
        schema: {
            typeId: ComponentTypeID.Button,
            description: 'Button element',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                variant: enumProp(BUTTON_VARIANTS, { default: 'primary' }),
                size: enumProp(BUTTON_SIZES, { default: 'md' }),
                icon: enumProp(BUTTON_ICONS),
                disabled: boolProp(false),
                loading: boolProp(false),
                spinnerPlacement: enumProp(BUTTON_SPINNER_PLACEMENTS, { default: 'start' }),
                spinnerSize: enumProp(BUTTON_SIZES),
                fullWidth: boolProp(false),
                type: enumProp(['button', 'submit', 'reset'], { default: 'button' }),
                form: stringProp(),
            }),
            events: ['click', 'focus', 'blur'],
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                loadingText: contentSlot({ multiple: true }),
                spinner: contentSlot(),
                leftIcon: contentSlot(),
                rightIcon: contentSlot(),
            }),
            elements: ['spinner'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'button',
                variants: BUTTON_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            fullWidth: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            icon: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            loading: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            spinnerPlacement: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            spinnerSize: {
                scanner: {
                    responsiveSupport: 'unsupported',
                    variantProjection: {
                        component: 'Spinner',
                        axis: 'size',
                        valuesByInput: {
                            sm: 'sm',
                            md: 'md',
                            lg: 'lg',
                        },
                    },
                },
            },
        },
    },
    ButtonGroup: {
        schema: {
            typeId: ComponentTypeID.ButtonGroup,
            description: 'Grouped button container',
            props: propsRecord({
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                variant: enumProp(BUTTON_VARIANTS),
                size: enumProp(BUTTON_SIZES),
                attached: boolProp(false),
                orientation: enumProp(BUTTON_GROUP_ORIENTATIONS, { default: 'horizontal' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'button-group',
                variants: BUTTON_GROUP_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            attached: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            orientation: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            size: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            variant: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    NavTree: {
        schema: {
            typeId: ComponentTypeID.NavTree,
            description: 'Navigation tree container',
            props: propsRecord({
                ...DIMENSION_UTILITY_PROPERTIES,
                ...BOX_MODEL_UTILITY_PROPERTIES,
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                groupSelection: boolProp(false, { description: 'NavTree-wide flag that groups visible descendant rows under a selected expanded parent. Enabling it also enables parent row selection.' }),
                selectParents: boolProp(false, { description: 'When true, parent rows can be selected and use the chevron for disclosure. When false, parent rows only disclose nested items.' }),
                droppable: boolProp(false, { description: 'Enables a drag-only end-of-tree target that appends an item at the root level.' }),
            }),
            events: ['dragEnter', 'dragOver', 'dragLeave', 'drop'],
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            elements: ['items'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'nav-tree',
                variants: NAV_TREE_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            size: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            groupSelection: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            selectParents: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            droppable: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    NavTreeSection: {
        schema: {
            typeId: ComponentTypeID.NavTreeSection,
            description: 'Section inside a navigation tree',
            props: propsRecord({}),
            slots: slotsRecord({
                title: contentSlot({ multiple: true }),
                endElement: contentSlot({ multiple: true, description: 'Optional trailing content rendered in the section header.' }),
                children: contentSlot({ multiple: true }),
            }),
            elements: ['header', 'title', 'end', 'items'],
        },
        styling: {
            support: 'utility-only',
        },
        propGuardrails: {},
    },
    NavTreeItem: {
        schema: {
            typeId: ComponentTypeID.NavTreeItem,
            description: 'Interactive item inside a recursive navigation tree. Items with children render accordion controls; parent row selection behavior is defined by the owning NavTree.',
            props: propsRecord({
                level: numberProp({
                    default: 1,
                    description: `Visual hierarchy level. Nested NavTreeItem children derive their level from the parent tree unless a standalone item sets this explicitly. Values from 1 to ${NAV_TREE_MAX_LEVEL} are supported for deeper recursive navigation.`,
                }),
                selected: boolProp(false, { description: 'Marks the item as the current navigation target.' }),
                disabled: boolProp(false, { description: 'Disables both row selection and disclosure controls.' }),
                expanded: boolProp(false, { description: 'Controls whether nested children are disclosed for parent items.' }),
                draggable: boolProp(false, { description: 'Enables native pointer drag-and-drop for this row. Drag sources can remain selectable and may also accept drops.' }),
                droppable: boolProp(false, { description: 'Enables native pointer drag-and-drop targeting inside this row, such as moving an item into a folder.' }),
                reorderable: boolProp(false, { description: 'Enables before/after boundary drops on this row for consumer-owned sibling reordering or tree reparenting.' }),
                reparentable: boolProp(false, { description: 'Enables boundary drops that move an item into a different sibling list, including outdenting after a parent.' }),
                reparentScope: enumProp(['tree', 'section'], { default: 'tree', description: 'Limits reparenting destinations. `section` keeps an item within its nearest NavTreeSection.' }),
                toggleLabel: stringProp({ description: 'Accessible label for the chevron disclosure control on parent items.' }),
                href: stringProp({ description: 'Optional link destination for navigational rows that should render with anchor semantics.' }),
                target: stringProp({ description: 'Optional link target when href is provided.' }),
            }),
            events: ['select', 'toggle', 'click', 'focus', 'blur', 'dragStart', 'dragEnd', 'dragEnter', 'dragOver', 'dragLeave', 'drop'],
            slots: slotsRecord({
                label: contentSlot({ multiple: true, description: 'Visible row content; use this instead of children for the item label.' }),
                children: contentSlot({ multiple: true, description: 'Nested NavTreeItem descendants rendered as recursive child rows; visible row content belongs in label.' }),
                startElement: contentSlot({ description: 'Optional leading icon or content slot before the label.' }),
                endElement: contentSlot({ description: 'Optional trailing icon or content slot after the label.' }),
            }),
            elements: ['row', 'content', 'control', 'main', 'toggle', 'toggleIcon', 'start', 'label', 'end', 'children', 'rail'],
        },
        styling: {
            support: 'utility-only',
        },
        propGuardrails: {
            level: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            selected: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            expanded: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            draggable: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            droppable: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            reorderable: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            reparentable: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            reparentScope: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            toggleLabel: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    DropdownMenu: {
        schema: {
            typeId: ComponentTypeID.DropdownMenu,
            description: 'Action-oriented dropdown menu root',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                open: boolProp(false),
                defaultOpen: boolProp(false),
                closeOnSelect: boolProp(true),
                positioning: objectProp({
                    placement: enumProp(DROPDOWN_MENU_PLACEMENTS, { default: 'bottom' }),
                    align: enumProp(DROPDOWN_MENU_ALIGNS, { default: 'start' }),
                    offset: numberProp({ default: 4 }),
                    strategy: enumProp(DROPDOWN_MENU_POSITION_STRATEGIES, { default: 'absolute' }),
                }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['openChange'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu',
                variants: DROPDOWN_MENU_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            open: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    DropdownMenuTrigger: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuTrigger,
            description: 'Button trigger that opens a DropdownMenu',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                asChild: boolProp(false, { description: 'Merge trigger behavior into a single child node' }),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                disabled: boolProp(false),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['click', 'keyDown'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-trigger',
                variants: DROPDOWN_MENU_TRIGGER_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    DropdownMenuContextTrigger: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuContextTrigger,
            description: 'Context-menu trigger that opens a DropdownMenu with pointer or keyboard input',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                asChild: boolProp(false),
                disabled: boolProp(false),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['contextMenu', 'keyDown'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-trigger',
                variants: DROPDOWN_MENU_TRIGGER_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    DropdownMenuContent: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuContent,
            description: 'Floating action menu content',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                positioning: objectProp({
                    placement: enumProp(DROPDOWN_MENU_PLACEMENTS, { default: 'bottom' }),
                    align: enumProp(DROPDOWN_MENU_ALIGNS, { default: 'start' }),
                    offset: numberProp({ default: 4 }),
                    strategy: enumProp(DROPDOWN_MENU_POSITION_STRATEGIES, { default: 'absolute' }),
                }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['keyDown'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-content',
                variants: DROPDOWN_MENU_CONTENT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    DropdownMenuItem: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuItem,
            description: 'Action item rendered inside a DropdownMenu',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                value: stringProp({ default: '' }),
                disabled: boolProp(false),
                destructive: boolProp(false),
                closeOnSelect: boolProp(true),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                startElement: contentSlot(),
                endElement: contentSlot({ multiple: true }),
                shortcut: contentSlot({ multiple: true }),
            }),
            events: ['select'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-item',
                variants: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            destructive: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    DropdownMenuCheckboxItem: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuCheckboxItem,
            description: 'Toggle action item rendered inside a DropdownMenu',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                value: stringProp({ default: '' }),
                checked: boolProp(false),
                disabled: boolProp(false),
                destructive: boolProp(false),
                closeOnSelect: boolProp(true),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                endElement: contentSlot({ multiple: true }),
                shortcut: contentSlot({ multiple: true }),
            }),
            events: ['checkedChange', 'select'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-item',
                variants: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            checked: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    DropdownMenuRadioGroup: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuRadioGroup,
            description: 'Radio item group rendered inside a DropdownMenu',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                value: stringProp({ default: '' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['valueChange'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-group',
                variants: DROPDOWN_MENU_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuRadioItem: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuRadioItem,
            description: 'Radio action item rendered inside a DropdownMenuRadioGroup',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                value: stringProp({ default: '' }),
                disabled: boolProp(false),
                destructive: boolProp(false),
                closeOnSelect: boolProp(true),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                endElement: contentSlot({ multiple: true }),
                shortcut: contentSlot({ multiple: true }),
            }),
            events: ['select'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-item',
                variants: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuGroup: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuGroup,
            description: 'Logical group inside a DropdownMenu',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-group',
                variants: DROPDOWN_MENU_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuLabel: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuLabel,
            description: 'Non-interactive label inside a DropdownMenu',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                inset: boolProp(false),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-label',
                variants: DROPDOWN_MENU_LABEL_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuSeparator: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuSeparator,
            description: 'Separator inside a DropdownMenu',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-separator',
                variants: DROPDOWN_MENU_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuShortcut: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuShortcut,
            description: 'Shortcut hint inside a DropdownMenuItem',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-shortcut',
                variants: DROPDOWN_MENU_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuSub: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuSub,
            description: 'Nested submenu container inside a DropdownMenu',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                open: boolProp(false),
                defaultOpen: boolProp(false),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['openChange'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-sub',
                variants: DROPDOWN_MENU_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuSubTrigger: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuSubTrigger,
            description: 'Trigger item for a DropdownMenu submenu',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                disabled: boolProp(false),
                destructive: boolProp(false),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                startElement: contentSlot(),
                shortcut: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-item',
                variants: DROPDOWN_MENU_ITEM_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    DropdownMenuSubContent: {
        schema: {
            typeId: ComponentTypeID.DropdownMenuSubContent,
            description: 'Nested submenu content',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'dropdown-menu-content',
                variants: DROPDOWN_MENU_CONTENT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    Modal: {
        schema: {
            typeId: ComponentTypeID.Modal,
            description: 'Blocking dialog root with controlled or uncontrolled open state',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                open: boolProp(false),
                defaultOpen: boolProp(false),
                closeOnEscape: boolProp(true),
                closeOnInteractOutside: boolProp(true),
                trapFocus: boolProp(true),
                restoreFocus: boolProp(true),
                initialFocusId: stringProp(),
                finalFocusId: stringProp(),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['openChange'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            open: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    ModalTrigger: {
        schema: {
            typeId: ComponentTypeID.ModalTrigger,
            description: 'Trigger that opens a Modal',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                asChild: boolProp(false, { description: 'Merge trigger behavior into a single child node' }),
                disabled: boolProp(false),
                type: enumProp(['button', 'submit', 'reset'], { default: 'button' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['click', 'keyDown'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-trigger',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalBackdrop: {
        schema: {
            typeId: ComponentTypeID.ModalBackdrop,
            description: 'Modal backdrop that blocks background interaction',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-backdrop',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalPositioner: {
        schema: {
            typeId: ComponentTypeID.ModalPositioner,
            description: 'Fixed modal overlay positioner',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                placement: enumProp(MODAL_PLACEMENTS, { default: 'center' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-positioner',
                variants: MODAL_POSITIONER_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalContent: {
        schema: {
            typeId: ComponentTypeID.ModalContent,
            description: 'Dialog surface rendered inside a Modal',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(MODAL_SIZES, { default: 'md' }),
                placement: enumProp(MODAL_PLACEMENTS, { default: 'center' }),
                scrollBehavior: enumProp(MODAL_SCROLL_BEHAVIORS, { default: 'inside' }),
                role: enumProp(MODAL_ROLES, { default: 'dialog' }),
                showCloseButton: boolProp(true),
                ariaLabelledBy: stringProp({
                    description: 'ID of the element that labels the modal dialog',
                }),
                ariaDescribedBy: stringProp({
                    description: 'ID of the element that describes the modal dialog',
                }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            elements: ['header', 'title', 'description', 'body', 'footer', 'closeTrigger', 'actionTrigger'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-content',
                variants: MODAL_CONTENT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalHeader: {
        schema: {
            typeId: ComponentTypeID.ModalHeader,
            description: 'Modal header layout',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-header',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalTitle: {
        schema: {
            typeId: ComponentTypeID.ModalTitle,
            description: 'Accessible modal title',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-title',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalDescription: {
        schema: {
            typeId: ComponentTypeID.ModalDescription,
            description: 'Optional modal description used for aria-describedby',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-description',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalBody: {
        schema: {
            typeId: ComponentTypeID.ModalBody,
            description: 'Modal body content area',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-body',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalFooter: {
        schema: {
            typeId: ComponentTypeID.ModalFooter,
            description: 'Optional modal footer action area',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-footer',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalCloseTrigger: {
        schema: {
            typeId: ComponentTypeID.ModalCloseTrigger,
            description: 'Button that closes a Modal',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                asChild: boolProp(false, { description: 'Merge close behavior into a single child node' }),
                type: enumProp(['button', 'submit', 'reset'], { default: 'button' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['click'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-close-trigger',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    ModalActionTrigger: {
        schema: {
            typeId: ComponentTypeID.ModalActionTrigger,
            description: 'Action button that closes a Modal without using close-icon styling',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                asChild: boolProp(false, { description: 'Merge action-close behavior into a single child node' }),
                type: enumProp(['button', 'submit', 'reset'], { default: 'button' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['click'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'modal-action-trigger',
                variants: MODAL_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    Breadcrumb: {
        schema: {
            typeId: ComponentTypeID.Breadcrumb,
            description: 'Breadcrumb navigation landmark for page hierarchy',
            props: propsRecord({
                ...DIMENSION_UTILITY_PROPERTIES,
                ...BOX_MODEL_UTILITY_PROPERTIES,
                ...VISIBILITY_UTILITY_PROPERTIES,
                as: stringProp({ description: 'Semantic tag override for the breadcrumb root.' }),
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                size: enumProp(BREADCRUMB_SIZES, { default: 'md' }),
                variant: enumProp(BREADCRUMB_VARIANTS, { default: 'plain' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            elements: ['list', 'item', 'link', 'currentLink', 'separator', 'ellipsis'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'breadcrumb',
                variants: BREADCRUMB_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            size: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            variant: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    BreadcrumbList: {
        schema: {
            typeId: ComponentTypeID.BreadcrumbList,
            description: 'Ordered list inside breadcrumb navigation',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                as: stringProp({ description: 'Semantic tag override for the breadcrumb list.' }),
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'breadcrumb-list',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    BreadcrumbItem: {
        schema: {
            typeId: ComponentTypeID.BreadcrumbItem,
            description: 'Item inside a breadcrumb list',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                as: stringProp({ description: 'Semantic tag override for the breadcrumb item.' }),
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'breadcrumb-item',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    BreadcrumbLink: {
        schema: {
            typeId: ComponentTypeID.BreadcrumbLink,
            description: 'Linked breadcrumb item',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                as: stringProp({ description: 'Semantic tag override for the breadcrumb link.' }),
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                href: stringProp({ description: 'Optional link destination for the breadcrumb item.' }),
                target: stringProp(),
                external: boolProp(false),
            }),
            events: ['click'],
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'breadcrumb-link',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    BreadcrumbCurrentLink: {
        schema: {
            typeId: ComponentTypeID.BreadcrumbCurrentLink,
            description: 'Current-page breadcrumb item',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                as: stringProp({ description: 'Semantic tag override for the current breadcrumb link.' }),
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                ariaCurrent: enumProp(['page', 'step', 'location', 'date', 'time'], {
                    default: 'page',
                    description: 'Marks this breadcrumb item as the current item in the trail.',
                }),
                ariaDisabled: boolProp(true, {
                    description: 'Marks the current breadcrumb item as disabled by default.',
                }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'breadcrumb-current-link',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    BreadcrumbSeparator: {
        schema: {
            typeId: ComponentTypeID.BreadcrumbSeparator,
            description: 'Decorative separator between breadcrumb items',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                as: stringProp({ description: 'Semantic tag override for the breadcrumb separator.' }),
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'breadcrumb-separator',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    BreadcrumbEllipsis: {
        schema: {
            typeId: ComponentTypeID.BreadcrumbEllipsis,
            description: 'Decorative breadcrumb overflow indicator',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                as: stringProp({ description: 'Semantic tag override for the breadcrumb ellipsis.' }),
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'breadcrumb-ellipsis',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    Table: {
        schema: {
            typeId: ComponentTypeID.Table,
            description: 'Semantic table for tabular data display',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                size: enumProp(TABLE_SIZES, { default: 'md' }),
                variant: enumProp(TABLE_VARIANTS, { default: 'line' }),
                striped: boolProp(false),
                interactive: boolProp(false),
                showColumnBorder: boolProp(false),
                stickyHeader: boolProp(false),
                layout: enumProp(TABLE_LAYOUTS, { default: 'auto' }),
                ...DIMENSION_UTILITY_PROPERTIES,
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                caption: contentSlot(),
                columnGroup: contentSlot(),
                header: contentSlot(),
                body: contentSlot(),
                footer: contentSlot(),
            }),
            elements: [
                'caption',
                'columnGroup',
                'column',
                'header',
                'body',
                'footer',
                'row',
                'columnHeader',
                'cell',
            ],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table',
                variants: TABLE_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            striped: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            interactive: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            showColumnBorder: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            stickyHeader: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    TableScrollArea: {
        schema: {
            typeId: ComponentTypeID.TableScrollArea,
            description: 'Horizontal scroll container for Table overflow',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                orientation: enumProp(SCROLL_AREA_ORIENTATIONS, {
                    default: 'horizontal',
                    description: 'Scrollable axis for the table container',
                }),
                variant: enumProp(SCROLL_AREA_VARIANTS, {
                    default: 'hover',
                    description: 'Scrollbar visibility behavior',
                }),
                scrollbar: enumProp(SCROLL_AREA_SCROLLBARS, {
                    default: 'auto',
                    description: 'Custom scrollbar rendering behavior',
                }),
                size: enumProp(SCROLL_AREA_SIZES, {
                    default: 'md',
                    description: 'Scrollbar thickness preset',
                }),
                gutter: enumProp(SCROLL_AREA_GUTTERS, {
                    default: 'stable',
                    description: 'Scrollbar gutter reservation behavior',
                }),
                frame: enumProp(['none', 'outline'], {
                    default: 'none',
                    description: 'Optional visual frame applied to the table scroll container.',
                }),
                viewportTabIndex: numberProp({
                    description: 'Tab index for the internal scroll viewport.',
                }),
                ...FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            elements: ['viewport', 'content', 'scrollbar', 'thumb', 'corner'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-scroll-area',
                variants: TABLE_SCROLL_AREA_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableCaption: {
        schema: {
            typeId: ComponentTypeID.TableCaption,
            description: 'Semantic table caption',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                side: enumProp(TABLE_CAPTION_SIDES, { default: 'bottom' }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-caption',
                variants: TABLE_CAPTION_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableColumnGroup: {
        schema: {
            typeId: ComponentTypeID.TableColumnGroup,
            description: 'Semantic table column group',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-column-group',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableColumn: {
        schema: {
            typeId: ComponentTypeID.TableColumn,
            description: 'Semantic table column',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...DIMENSION_UTILITY_PROPERTIES,
                span: numberProp(),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-column',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableHeader: {
        schema: {
            typeId: ComponentTypeID.TableHeader,
            description: 'Semantic table header group',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-header',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableBody: {
        schema: {
            typeId: ComponentTypeID.TableBody,
            description: 'Semantic table body group',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-body',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableFooter: {
        schema: {
            typeId: ComponentTypeID.TableFooter,
            description: 'Semantic table footer group',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-footer',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableRow: {
        schema: {
            typeId: ComponentTypeID.TableRow,
            description: 'Semantic table row',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...CURSOR_UTILITY_PROPERTY,
                selected: boolProp(false),
                emphasized: boolProp(false, {
                    description: 'Visually emphasize a summary or total row without implying selection',
                }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['click', 'keyDown'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-row',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    TableColumnHeader: {
        schema: {
            typeId: ComponentTypeID.TableColumnHeader,
            description: 'Semantic table header cell',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...DIMENSION_UTILITY_PROPERTIES,
                scope: enumProp(TABLE_HEADER_SCOPES, { default: 'col' }),
                sticky: enumProp(TABLE_STICKY_POSITIONS),
                colSpan: numberProp(),
                rowSpan: numberProp(),
                textAlign: enumProp(TEXT_ALIGNMENTS),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-column-header',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            colSpan: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            rowSpan: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    TableCell: {
        schema: {
            typeId: ComponentTypeID.TableCell,
            description: 'Semantic table data cell',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...DIMENSION_UTILITY_PROPERTIES,
                sticky: enumProp(TABLE_STICKY_POSITIONS),
                colSpan: numberProp(),
                rowSpan: numberProp(),
                textAlign: enumProp(TEXT_ALIGNMENTS),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'table-cell',
                variants: TABLE_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            colSpan: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            rowSpan: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    Chart: {
        schema: {
            typeId: ComponentTypeID.Chart,
            description: 'Bounded accessible chart for small analytical datasets',
            props: propsRecord({
                title: stringProp({ required: true }),
                description: stringProp(),
                xAxisLabel: stringProp({ description: 'Visible horizontal-axis title for bar and line charts' }),
                yAxisLabel: stringProp({ description: 'Visible vertical-axis title for bar and line charts' }),
                data: objectProp({
                    type: enumProp(CHART_KINDS, { required: true }),
                    labels: arrayProp(stringProp(), { required: true }),
                    datasets: arrayProp(objectProp({
                        label: stringProp({ required: true }),
                        data: arrayProp(numberProp(), { required: true }),
                    }), { required: true }),
                }, { required: true }),
                showLegend: boolProp(),
            }),
            elements: ['header', 'title', 'description', 'plot', 'legend', 'fallbackTable'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'chart',
                variants: CHART_RECIPE_VARIANTS,
            },
        },
    },
    Tabs: {
        schema: {
            typeId: ComponentTypeID.Tabs,
            description: 'Tabs accessible tabbed content part',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                variant: enumProp(TABS_VARIANTS, { default: 'line' }),
                value: stringProp(),
                defaultValue: stringProp(),
                orientation: enumProp(TABS_ORIENTATIONS, { default: 'horizontal', responsive: false }),
                activationMode: enumProp(TABS_ACTIVATION_MODES, {
                    default: 'automatic',
                    responsive: false,
                }),
                loopFocus: boolProp(true),
                lazyMount: boolProp(false),
                unmountOnExit: boolProp(false),
            }),
            events: ['valueChange'],
            slots: slotsRecord({ children: contentSlot({ multiple: true }) }),
        },
        styling: { support: 'recipe-backed', recipe: { name: 'tabs', variants: TABS_RECIPE_VARIANTS } },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            orientation: { scanner: { responsiveSupport: 'unsupported' } },
            activationMode: { scanner: { responsiveSupport: 'unsupported' } },
            loopFocus: { scanner: { responsiveSupport: 'unsupported' } },
            lazyMount: { scanner: { responsiveSupport: 'unsupported' } },
            unmountOnExit: { scanner: { responsiveSupport: 'unsupported' } },
        },
    },
    TabsList: {
        schema: {
            typeId: ComponentTypeID.TabsList,
            description: 'TabsList accessible tabbed content part',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                showSeparator: boolProp(true, {
                    description: 'Show separators between inactive tabs; false uses a 4px gap',
                }),
            }),
            slots: slotsRecord({ children: contentSlot({ multiple: true }) }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: { name: 'tabs-list', variants: EMPTY_RECIPE_VARIANTS },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            showSeparator: { scanner: { responsiveSupport: 'unsupported' } },
        },
    },
    TabsTrigger: {
        schema: {
            typeId: ComponentTypeID.TabsTrigger,
            description: 'TabsTrigger accessible tabbed content part',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                value: stringProp({ required: true }),
                disabled: boolProp(false),
            }),
            events: ['click', 'keyDown', 'focus', 'blur', 'mouseDown', 'mouseEnter', 'mouseLeave'],
            slots: slotsRecord({ children: contentSlot({ multiple: true }) }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: { name: 'tabs-trigger', variants: EMPTY_RECIPE_VARIANTS },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            disabled: { scanner: { responsiveSupport: 'unsupported' } },
        },
    },
    TabsContent: {
        schema: {
            typeId: ComponentTypeID.TabsContent,
            description: 'TabsContent accessible tabbed content part',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
                direction: enumProp(STACK_DIRECTIONS, { default: 'column' }),
                gap: spacingProp({ description: 'Spacing between panel children' }),
                align: enumProp(LAYOUT_ALIGNMENTS),
                justify: enumProp(STACK_JUSTIFICATIONS),
                wrap: boolProp(false),
                background: colorTokenProp({
                    description: 'Panel surface shared with its selected outline tab',
                }),
                value: stringProp({ required: true }),
            }),
            slots: slotsRecord({ children: contentSlot({ multiple: true }) }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: { name: 'tabs-content', variants: EMPTY_RECIPE_VARIANTS },
        },
        propGuardrails: { ...VISIBILITY_PROP_GUARDRAILS },
    },
    Accordion: {
        schema: {
            typeId: ComponentTypeID.Accordion,
            description: 'Collapsible grouped content disclosure for structured information',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                size: enumProp(ACCORDION_SIZES, { default: 'md' }),
                variant: enumProp(ACCORDION_VARIANTS, { default: 'outline' }),
                multiple: boolProp(false),
                collapsible: boolProp(false),
                disabled: boolProp(false),
                value: stringOrStringArrayProp(),
                defaultValue: stringOrStringArrayProp(),
            }),
            events: ['valueChange'],
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            elements: [
                'item',
                'trigger',
                'indicator',
                'content',
                'body',
            ],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'accordion',
                variants: ACCORDION_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            multiple: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            collapsible: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    AccordionItem: {
        schema: {
            typeId: ComponentTypeID.AccordionItem,
            description: 'Accordion item with a trigger and collapsible content',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                value: stringProp({ required: true }),
                disabled: boolProp(false),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'accordion-item',
                variants: ACCORDION_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    AccordionTrigger: {
        schema: {
            typeId: ComponentTypeID.AccordionTrigger,
            description: 'Accordion item button that toggles content visibility',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                disabled: boolProp(false),
                type: enumProp(['button', 'submit', 'reset'], { default: 'button' }),
                form: stringProp(),
                name: stringProp(),
                value: stringOrNumberProp(),
            }),
            events: ['click', 'keyDown', 'focus', 'blur'],
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'accordion-trigger',
                variants: ACCORDION_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    AccordionIndicator: {
        schema: {
            typeId: ComponentTypeID.AccordionIndicator,
            description: 'Accordion trigger indicator',
            props: propsRecord(VISIBILITY_UTILITY_PROPERTIES),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'accordion-indicator',
                variants: ACCORDION_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    AccordionContent: {
        schema: {
            typeId: ComponentTypeID.AccordionContent,
            description: 'Accordion item collapsible content region',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'accordion-content',
                variants: ACCORDION_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    AccordionBody: {
        schema: {
            typeId: ComponentTypeID.AccordionBody,
            description: 'Accordion content body padding wrapper',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'accordion-body',
                variants: ACCORDION_EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: VISIBILITY_PROP_GUARDRAILS,
    },
    Flyout: {
        schema: {
            typeId: ComponentTypeID.Flyout,
            description: 'Floating listbox surface for selectable items',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                positioning: objectProp({
                    placement: enumProp(FLYOUT_PLACEMENTS, { default: 'bottom' }),
                }),
            }),
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
            }),
            events: ['mouseDown'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'flyout',
                variants: FLYOUT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    FlyoutItem: {
        schema: {
            typeId: ComponentTypeID.FlyoutItem,
            description: 'Selectable item rendered inside a Flyout',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                state: enumProp(FLYOUT_ITEM_STATES, { default: 'default' }),
                selected: boolProp(false),
                highlighted: boolProp(false),
                disabled: boolProp(false),
            }),
            events: ['click', 'focus', 'blur'],
            slots: slotsRecord({
                children: contentSlot({ multiple: true }),
                startElement: contentSlot(),
                suffix: contentSlot({ multiple: true }),
            }),
            elements: ['check', 'start', 'suffix'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'flyout-item',
                variants: FLYOUT_ITEM_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            selected: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    Checkbox: {
        schema: {
            typeId: ComponentTypeID.Checkbox,
            description: 'Checkbox input',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                name: stringProp(),
                form: stringProp(),
                value: stringProp(),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                variant: enumProp(CHECKBOX_VARIANTS, { default: 'solid' }),
                label: stringProp(),
                labelPosition: enumProp(CHECKBOX_LABEL_POSITIONS, { default: 'end' }),
                checked: boolProp(false),
                indeterminate: boolProp(false),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
            }),
            events: ['change'],
            slots: slotsRecord({
                label: textSlot({ multiple: true }),
            }),
            elements: ['field', 'label'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'checkbox',
                variants: CHECKBOX_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    CheckboxGroup: {
        schema: {
            typeId: ComponentTypeID.CheckboxGroup,
            description: 'Grouped checkbox container',
            props: propsRecord({
                orientation: enumProp(FORM_ORIENTATIONS, { default: 'vertical' }),
                value: arrayProp(stringProp({ required: true })),
                name: stringProp(),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
            }),
            events: ['change'],
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'checkbox-group',
                variants: CHECKBOX_GROUP_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    Flex: {
        schema: {
            typeId: ComponentTypeID.Flex,
            description: 'Low-level flexbox container',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                direction: enumProp(STACK_DIRECTIONS, {
                    default: 'row',
                    description: 'Flex direction for child layout',
                }),
                gap: spacingProp({
                    description: 'Spacing between children (numeric spacing step)',
                }),
                align: enumProp(LAYOUT_ALIGNMENTS, { description: 'Cross-axis alignment' }),
                justify: enumProp(STACK_JUSTIFICATIONS, {
                    description: 'Main-axis justification',
                }),
                ...DIVIDED_FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
                wrap: boolProp(false, { description: 'Allow children to wrap across multiple lines' }),
                inline: boolProp(false, { description: 'Render as inline-flex instead of flex' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'flex',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    Field: {
        schema: {
            typeId: ComponentTypeID.Field,
            description: 'Shared field wrapper',
            props: propsRecord({
                orientation: enumProp(FORM_ORIENTATIONS, { default: 'vertical' }),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
                indicator: enumProp(FIELD_INDICATORS, { default: 'required' }),
                optionalText: stringProp({ default: '(Optional)' }),
            }),
            slots: ['children'],
            elements: ['label', 'description', 'error', 'requiredIndicator'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'field',
                variants: FIELD_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            readOnly: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    FieldDescription: {
        schema: {
            typeId: ComponentTypeID.FieldDescription,
            description: 'Supporting field description',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                align: enumProp(TEXT_ALIGNMENTS, { default: 'left', description: 'Text alignment' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'field-description',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
    },
    FieldError: {
        schema: {
            typeId: ComponentTypeID.FieldError,
            description: 'Field error message',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'field-error',
                variants: FIELD_ERROR_RECIPE_VARIANTS,
            },
        },
    },
    FieldGroup: {
        schema: {
            typeId: ComponentTypeID.FieldGroup,
            description: 'Field grouping container',
            props: propsRecord({
                orientation: enumProp(FORM_ORIENTATIONS, { default: 'vertical' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'field-group',
                variants: FIELD_GROUP_RECIPE_VARIANTS,
            },
        },
    },
    FieldLabel: {
        schema: {
            typeId: ComponentTypeID.FieldLabel,
            description: 'Field label',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                htmlFor: stringProp(),
                required: boolProp(false),
                optionalText: stringProp(),
            }),
            slots: ['children'],
            elements: ['requiredIndicator'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'field-label',
                variants: FIELD_LABEL_RECIPE_VARIANTS,
            },
        },
    },
    InputCharacterCount: {
        schema: {
            typeId: ComponentTypeID.InputCharacterCount,
            description: 'Input character count helper',
            props: propsRecord({
                value: stringProp(),
                current: numberProp(),
                max: numberProp(),
            }),
            slots: [],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'input-character-count',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
    },
    FieldLegend: {
        schema: {
            typeId: ComponentTypeID.FieldLegend,
            description: 'Fieldset legend',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                required: boolProp(false),
                optionalText: stringProp(),
            }),
            slots: ['children'],
            elements: ['requiredIndicator'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'field-legend',
                variants: FIELD_LABEL_RECIPE_VARIANTS,
            },
        },
    },
    FieldSet: {
        schema: {
            typeId: ComponentTypeID.FieldSet,
            description: 'Grouped field wrapper',
            props: propsRecord({
                orientation: enumProp(FORM_ORIENTATIONS, { default: 'vertical' }),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
            }),
            slots: ['children'],
            elements: ['legend', 'description', 'error', 'content', 'requiredIndicator'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'field-set',
                variants: FIELD_SET_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            readOnly: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    Code: {
        schema: {
            typeId: ComponentTypeID.Code,
            description: 'Inline code',
            props: propsRecord({
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                size: enumProp(CODE_SIZES, { default: 'sm' }),
                variant: enumProp(CODE_VARIANTS, { default: 'subtle' }),
                color: enumProp(CODE_RECIPE_COLORS, { default: 'default' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'code',
                variants: CODE_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            color: {
                scanner: {
                    detection: 'enum-or-extension-only',
                },
            },
        },
    },
    CodeBlock: {
        schema: {
            typeId: ComponentTypeID.CodeBlock,
            description: 'Block code presentation',
            props: propsRecord({
                code: stringProp({ description: 'Raw code source to render and highlight' }),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                language: stringProp(),
                background: colorTokenProp({ description: 'Code block background color (token or raw color)' }),
                backgroundColor: colorTokenProp({ description: 'Code block background color alias (token or raw color)' }),
                wrap: boolProp(false, { description: 'Wrap long lines instead of scrolling horizontally' }),
                showLineNumbers: boolProp(false, { description: 'Render line numbers alongside the highlighted code' }),
                highlightLines: arrayProp(numberProp({ required: true }), {
                    description: 'Line numbers to emphasize with a highlight treatment',
                }),
                focusedLineNumbers: arrayProp(numberProp({ required: true }), {
                    description: 'Line numbers to keep fully emphasized while dimming surrounding lines',
                }),
                addedLineNumbers: arrayProp(numberProp({ required: true }), {
                    description: 'Line numbers to render as added diff lines',
                }),
                removedLineNumbers: arrayProp(numberProp({ required: true }), {
                    description: 'Line numbers to render as removed diff lines',
                }),
            }),
            slots: ['children'],
            elements: ['header', 'title', 'control', 'copyTrigger', 'content', 'code', 'codeText'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'code-block',
                variants: CODE_BLOCK_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            background: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            backgroundColor: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            showLineNumbers: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            highlightLines: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            focusedLineNumbers: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            addedLineNumbers: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            removedLineNumbers: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    StackCol: {
        schema: {
            typeId: ComponentTypeID.StackCol,
            description: 'Vertical flex container',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                gap: spacingProp({
                    default: 4,
                    description: 'Spacing between children (numeric spacing step)',
                }),
                align: enumProp(LAYOUT_ALIGNMENTS, { default: 'stretch', description: 'Cross-axis alignment' }),
                justify: enumProp(STACK_JUSTIFICATIONS, {
                    default: 'start',
                    description: 'Main-axis justification',
                }),
                ...DIVIDED_FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
                wrap: boolProp(false, { description: 'Allow children to wrap to multiple columns' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'stack-col',
                variants: STACK_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    Divider: {
        schema: {
            typeId: ComponentTypeID.Divider,
            description: 'Visual divider',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                orientation: enumProp(DIVIDER_ORIENTATIONS, { default: 'horizontal' }),
                variant: enumProp(DIVIDER_VARIANTS, {
                    default: 'solid',
                    description: 'Divider stroke style',
                }),
                size: borderWidthProp({
                    default: 1,
                    description: 'Divider thickness (border width token, number, or explicit CSS length)',
                }),
                ...DIMENSION_UTILITY_PROPERTIES,
                margin: spacingProp({
                    description: 'Outer margin (numeric spacing step or axis-specific object)',
                    properties: GROUPED_SPACING_AXIS_PROPERTIES,
                }),
                ...AXIS_SPACING_UTILITY_PROPERTIES,
                background: colorTokenProp({
                    default: 'borderSubtle',
                    description: 'Divider stroke color (token or raw color)',
                }),
                backgroundColor: colorTokenProp({ description: 'Divider stroke color alias (token or raw color)' }),
                ...FLEX_SIZE_UTILITY_PROPERTIES,
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'divider',
                variants: DIVIDER_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    Grid: {
        schema: {
            typeId: ComponentTypeID.Grid,
            description: 'CSS Grid container',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                columns: stringOrNumberProp({
                    default: 1,
                    description: 'Grid column tracks as a count or explicit CSS template string',
                }),
                cols: numberProp({
                    deprecated: true,
                    description: 'Deprecated alias for columns',
                }),
                rows: stringOrNumberProp({
                    description: 'Grid row tracks as a count or explicit CSS template string',
                }),
                areas: stringProp({ description: 'Named grid template areas string' }),
                flow: stringProp({ description: 'Grid auto-placement flow' }),
                autoRows: stringProp({ description: 'Implicit row track sizing' }),
                autoColumns: stringProp({ description: 'Implicit column track sizing' }),
                inline: boolProp(undefined, { description: 'Render as inline-grid instead of grid' }),
                gap: spacingProp({
                    default: 4,
                    description: 'Spacing between cells (numeric spacing step)',
                }),
                gapX: spacingProp({ description: 'Column gap (numeric spacing step)' }),
                gapY: spacingProp({ description: 'Row gap (numeric spacing step)' }),
                align: enumProp(LAYOUT_ALIGNMENTS, { description: 'Cross-axis alignment' }),
                justify: enumProp(STACK_JUSTIFICATIONS, { description: 'Main-axis justification' }),
                alignItems: stringProp({ description: 'Explicit align-items value for grid children' }),
                justifyContent: stringProp({ description: 'Explicit justify-content value for the grid tracks' }),
                justifyItems: stringProp({ description: 'Explicit justify-items value for grid children' }),
                alignContent: stringProp({ description: 'Explicit align-content value for grid tracks' }),
                placeContent: stringProp({ description: 'Explicit place-content shorthand for grid tracks' }),
                placeItems: stringProp({ description: 'Explicit place-items shorthand for grid children' }),
                ...DIVIDED_CONTAINER_SURFACE_UTILITY_PROPERTIES,
            }),
            slots: ['children'],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'grid',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    GridItem: {
        schema: {
            typeId: ComponentTypeID.GridItem,
            description: 'Grid item placement helper',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                area: stringProp({ description: 'Grid area assignment or shorthand placement string' }),
                colSpan: stringOrNumberProp({ description: 'Column span count or auto' }),
                colStart: stringOrNumberProp({ description: 'Grid column start line or auto' }),
                colEnd: stringOrNumberProp({ description: 'Grid column end line or auto' }),
                rowSpan: stringOrNumberProp({ description: 'Row span count or auto' }),
                rowStart: stringOrNumberProp({ description: 'Grid row start line or auto' }),
                rowEnd: stringOrNumberProp({ description: 'Grid row end line or auto' }),
                justifySelf: stringProp({ description: 'Explicit justify-self value for the grid item' }),
                alignSelf: stringProp({ description: 'Explicit align-self value for the grid item' }),
                placeContent: stringProp({ description: 'Explicit place-content shorthand when the grid item also acts as a grid container' }),
                placeItems: stringProp({ description: 'Explicit place-items shorthand when the grid item also acts as a grid container' }),
                placeSelf: stringProp({ description: 'Explicit place-self shorthand for the grid item' }),
                ...DIVIDED_FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
            }),
            slots: ['children'],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'grid-item',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    Heading: {
        schema: {
            typeId: ComponentTypeID.Heading,
            description: 'Heading element',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                level: enumProp(HEADING_LEVELS, { default: 2 }),
                size: enumProp(TEXT_SIZES),
                weight: enumProp(TEXT_RECIPE_WEIGHTS, { default: 'bold' }),
                align: enumProp(TEXT_ALIGNMENTS, { default: 'left' }),
                color: enumProp(TEXT_RECIPE_COLORS, { default: 'default' }),
                uppercase: boolProp(false, { description: 'Transform text to uppercase' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'heading',
                variants: TEXT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            color: {
                scanner: {
                    detection: 'enum-or-extension-only',
                    responsiveSupport: 'unsupported',
                },
            },
            level: {
                scanner: {
                    responsiveSupport: 'unsupported',
                    variantProjection: {
                        axis: 'size',
                        valuesByInput: {
                            '1': '4xl',
                            '2': '3xl',
                            '3': '2xl',
                            '4': 'xl',
                            '5': 'lg',
                            '6': 'md',
                        },
                    },
                },
            },
        },
    },
    Label: {
        schema: {
            typeId: ComponentTypeID.Label,
            description: 'Form label',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                htmlFor: stringProp(),
                size: enumProp(TEXT_SIZES, { default: 'sm' }),
                weight: enumProp(FONT_WEIGHTS, { default: 'medium' }),
                required: boolProp(false),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'label',
                variants: LABEL_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            textStyle: {
                scanner: {
                    responsiveSupport: 'supported',
                },
            },
        },
    },
    Link: {
        schema: {
            typeId: ComponentTypeID.Link,
            description: 'Link element',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                href: stringProp({ required: true }),
                target: stringProp(),
                size: enumProp(TEXT_SIZES),
                underline: enumProp(LINK_UNDERLINES, { default: 'always' }),
                variant: enumProp(LINK_RECIPE_VARIANTS.variant, { default: 'primary' }),
                external: boolProp(false),
            }),
            events: ['click'],
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'link',
                variants: LINK_RECIPE_VARIANTS,
            },
        },
    },
    Progress: {
        schema: {
            typeId: ComponentTypeID.Progress,
            description: 'Progress bar',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                value: numberProp({ description: 'Current progress value; omitted for indeterminate progress.' }),
                max: numberProp({ default: 100 }),
                size: enumProp(BUTTON_SIZES, { default: 'md' }),
                showLabel: boolProp(false),
                indeterminate: boolProp(false),
            }),
            elements: ['field', 'label'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'progress',
                variants: PROGRESS_RECIPE_VARIANTS,
            },
        },
    },
    Radio: {
        schema: {
            typeId: ComponentTypeID.Radio,
            description: 'Radio input',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                value: stringProp({ required: true }),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                variant: enumProp(CHECKBOX_VARIANTS, { default: 'solid' }),
                label: stringProp(),
                labelPosition: enumProp(CHECKBOX_LABEL_POSITIONS, { default: 'end' }),
                checked: boolProp(false),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
                name: stringProp(),
                form: stringProp(),
            }),
            events: ['change'],
            slots: slotsRecord({
                label: textSlot({ multiple: true }),
            }),
            elements: ['field', 'label'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'radio',
                variants: RADIO_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    RadioGroup: {
        schema: {
            typeId: ComponentTypeID.RadioGroup,
            description: 'Grouped radio container',
            props: propsRecord({
                orientation: enumProp(FORM_ORIENTATIONS, { default: 'vertical' }),
                value: stringProp(),
                name: stringProp(),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
            }),
            events: ['change'],
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'radio-group',
                variants: RADIO_GROUP_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    StackRow: {
        schema: {
            typeId: ComponentTypeID.StackRow,
            description: 'Horizontal flex container',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                gap: spacingProp({
                    default: 4,
                    description: 'Spacing between children (numeric spacing step)',
                }),
                align: enumProp(LAYOUT_ALIGNMENTS, { default: 'center', description: 'Cross-axis alignment' }),
                justify: enumProp(STACK_JUSTIFICATIONS, {
                    default: 'start',
                    description: 'Main-axis justification',
                }),
                ...DIVIDED_FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
                wrap: boolProp(false, { description: 'Allow children to wrap to multiple rows' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'stack-row',
                variants: STACK_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    ScrollArea: {
        schema: {
            typeId: ComponentTypeID.ScrollArea,
            description: 'Scrollable container',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                orientation: enumProp(SCROLL_AREA_ORIENTATIONS, {
                    default: 'vertical',
                    description: 'Scrollable axis for the container',
                }),
                variant: enumProp(SCROLL_AREA_VARIANTS, {
                    default: 'hover',
                    description: 'Scrollbar visibility behavior',
                }),
                scrollbar: enumProp(SCROLL_AREA_SCROLLBARS, {
                    default: 'auto',
                    description: 'Custom scrollbar rendering behavior',
                }),
                size: enumProp(SCROLL_AREA_SIZES, {
                    default: 'md',
                    description: 'Scrollbar thickness preset',
                }),
                gutter: enumProp(SCROLL_AREA_GUTTERS, {
                    default: 'overlay',
                    description: 'Scrollbar gutter reservation behavior',
                }),
                viewportTabIndex: numberProp({
                    description: 'Tab index for the internal scroll viewport.',
                }),
                ...FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'scroll-area',
                variants: SCROLL_AREA_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    Select: {
        schema: {
            typeId: ComponentTypeID.Select,
            description: 'Select dropdown',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...DIMENSION_UTILITY_PROPERTIES,
                name: stringProp(),
                value: stringProp(),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                variant: enumProp(SELECT_VARIANTS, { default: 'filled' }),
                options: arrayProp(objectProp({
                    value: stringProp({ required: true }),
                    label: stringProp({ required: true }),
                    group: stringProp(),
                    description: stringProp(),
                    startElement: contentProp(),
                    suffix: contentProp(),
                    disabled: boolProp(false),
                }), {
                    required: true,
                    accessor: true,
                    description: 'Selectable options',
                }),
                placeholder: stringProp(),
                positioning: objectProp({
                    placement: enumProp(FLYOUT_PLACEMENTS, { default: 'bottom' }),
                }),
                searchable: boolProp(false, { accessor: true }),
                showSelectedIcon: boolProp(false),
                searchPlaceholder: stringProp(),
                emptyStateMessage: stringProp({ accessor: true }),
                noResultsMessage: stringProp(),
                footerAction: objectProp({
                    label: stringProp({ required: true }),
                    startElement: contentProp(),
                    position: enumProp(['scroll', 'sticky'], { default: 'scroll' }),
                }, {
                    accessor: true,
                    description: 'Separated footer action label. Runtime code supplies the click handler.',
                }),
                error: boolProp(false),
                invalid: boolProp(false),
                disabled: boolProp(false, { accessor: true }),
                required: boolProp(false),
            }),
            events: ['change', 'focus', 'blur', 'openRequest'],
            slots: slotsRecord({
                startElement: contentSlot(),
                prefix: contentSlot({ multiple: true }),
                suffix: contentSlot({ multiple: true }),
                options: dataSlot(objectProp({
                    value: stringProp({ required: true }),
                    label: stringProp({ required: true }),
                    group: stringProp(),
                    description: stringProp(),
                    startElement: contentProp(),
                    suffix: contentProp(),
                    disabled: boolProp(false),
                }), { multiple: true }),
                footerAction: dataSlot(objectProp({
                    label: stringProp({ required: true }),
                    startElement: contentProp(),
                    position: enumProp(['scroll', 'sticky'], { default: 'scroll' }),
                })),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'select',
                variants: SELECT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            error: {
                scanner: {
                    responsiveSupport: 'unsupported',
                    variantProjection: {
                        axis: 'invalid',
                        valuesByInput: {
                            true: 'true',
                            false: 'false',
                        },
                    },
                },
            },
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    SegmentedControl: {
        schema: {
            typeId: ComponentTypeID.SegmentedControl,
            description: 'Single-choice segmented control',
            props: propsRecord({
                name: stringProp(),
                value: stringProp(),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                variant: enumProp(SEGMENTED_CONTROL_VARIANTS, { default: 'default' }),
                itemContent: enumProp(SEGMENTED_CONTROL_ITEM_CONTENTS, { default: 'text' }),
                orientation: enumProp(FORM_ORIENTATIONS, { default: 'horizontal' }),
                layout: enumProp(SEGMENTED_CONTROL_LAYOUTS, { default: 'hug' }),
                options: arrayProp(objectProp({
                    value: stringProp({ required: true }),
                    label: stringProp({ required: true }),
                    icon: contentProp({ description: 'Optional icon content used when itemContent includes icons' }),
                    disabled: boolProp(false),
                }), {
                    required: true,
                    description: 'Linear option set for the segmented control',
                }),
                invalid: boolProp(false),
                disabled: boolProp(false),
                required: boolProp(false),
            }),
            events: ['change'],
            elements: ['indicator', 'item', 'itemInput', 'itemLabel', 'itemIcon', 'itemText'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'segmented-control',
                variants: SEGMENTED_CONTROL_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            itemContent: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            orientation: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            layout: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            variant: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    Spacer: {
        schema: {
            typeId: ComponentTypeID.Spacer,
            description: 'Flexible spacer',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
                ...FLEX_ITEM_ALIGNMENT_UTILITY_PROPERTIES,
                basis: sizeTokenProp({ default: 0, description: 'Flex basis (size token, number, or explicit CSS value)' }),
                grow: numberProp({ default: 1, description: 'Flex grow factor.' }),
                shrink: numberProp({ default: 1, description: 'Flex shrink factor.' }),
                alignSelf: stringProp({ default: 'stretch', description: 'Explicit align-self value for the spacer item' }),
                justifySelf: stringProp({ default: 'stretch', description: 'Explicit justify-self value for the spacer item' }),
            }),
            slots: [],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'spacer',
                variants: EMPTY_RECIPE_VARIANTS,
            },
        },
    },
    Spinner: {
        schema: {
            typeId: ComponentTypeID.Spinner,
            description: 'Loading spinner',
            props: propsRecord({
                size: enumProp(SPINNER_SIZES, { default: 'md' }),
                label: stringProp({ default: 'Loading...' }),
                color: colorTokenProp({ default: 'surfaceInverse', description: 'Spinner arc color token' }),
                trackColor: colorTokenProp({ default: 'surfaceInverseAlpha32', description: 'Spinner track color token' }),
                borderWidth: stringOrNumberProp({ description: 'Spinner stroke width as a CSS length or pixel number' }),
                animationDuration: stringProp({ default: '800ms', description: 'Spinner rotation animation duration' }),
            }),
            slots: [],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'spinner',
                variants: SPINNER_RECIPE_VARIANTS,
            },
        },
    },
    Stack: {
        schema: {
            typeId: ComponentTypeID.Stack,
            description: 'Flexible linear layout container',
            props: propsRecord({
                ...DISPLAY_UTILITY_PROPERTY,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                direction: enumProp(STACK_DIRECTIONS, {
                    default: 'column',
                    description: 'Direction to stack children',
                }),
                gap: spacingProp({
                    default: 4,
                    description: 'Spacing between children (numeric spacing step)',
                }),
                align: enumProp(LAYOUT_ALIGNMENTS, { default: 'stretch', description: 'Cross-axis alignment' }),
                justify: enumProp(STACK_JUSTIFICATIONS, {
                    default: 'start',
                    description: 'Main-axis justification',
                }),
                ...DIVIDED_FLEXIBLE_CONTAINER_SURFACE_UTILITY_PROPERTIES,
                wrap: boolProp(false, { description: 'Allow children to wrap across the cross axis' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'utility-only',
            recipe: {
                name: 'stack',
                variants: STACK_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
        },
    },
    Switch: {
        schema: {
            typeId: ComponentTypeID.Switch,
            description: 'Toggle switch',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                name: stringProp(),
                size: enumProp(CONTROL_SIZES),
                label: stringProp(),
                checked: boolProp(false),
                invalid: boolProp(false),
                disabled: boolProp(false),
                required: boolProp(false),
            }),
            events: ['change'],
            slots: slotsRecord({
                label: textSlot({ multiple: true }),
            }),
            elements: ['field', 'input', 'control', 'indicator', 'label'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'switch',
                variants: SWITCH_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            checked: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    Composer: {
        schema: {
            typeId: ComponentTypeID.Composer,
            description: 'Controlled multi-line AI chat composer',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...DIMENSION_UTILITY_PROPERTIES,
                name: stringProp(),
                value: stringProp(),
                placeholder: stringProp(),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                focusRing: enumProp(FOCUS_RING_PLACEMENTS, { default: 'none', description: 'Focus-ring placement for every focus interaction.' }),
                focusVisibleRing: enumProp(FOCUS_RING_PLACEMENTS, { description: 'Focus-ring placement when the browser considers focus visible.' }),
                autoresize: boolProp(true),
                minLength: numberProp(),
                maxLength: numberProp(),
                status: enumProp(COMPOSER_STATUSES, { default: 'idle', description: 'Controlled message activity state.' }),
                submitMode: enumProp(COMPOSER_SUBMIT_MODES, { default: 'enter', description: 'Keyboard shortcut that submits a non-empty message.' }),
                attachment: objectProp({
                    ariaLabel: stringProp(),
                    disabled: boolProp(false),
                    icon: contentProp({ description: 'Optional replacement icon for the attachment trigger.' }),
                }, { description: 'Optional application-owned attachment trigger configuration.' }),
                sendLabel: stringProp({ description: 'Accessible label for the send action.' }),
                sendIcon: contentProp({ description: 'Optional replacement icon for the send action.' }),
                stopLabel: stringProp({ description: 'Accessible label for the stop action.' }),
                stopIcon: contentProp({ description: 'Optional replacement icon for the stop action.' }),
                error: boolProp(false),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
            }),
            events: ['input', 'change', 'focus', 'blur', 'submit', 'cancel', 'attach'],
            slots: slotsRecord({
                tools: contentSlot({ multiple: true, description: 'Application-owned tools rendered before Send.' }),
            }),
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'composer',
                variants: COMPOSER_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            error: {
                scanner: {
                    responsiveSupport: 'unsupported',
                    variantProjection: {
                        axis: 'invalid',
                        valuesByInput: {
                            true: 'true',
                            false: 'false',
                        },
                    },
                },
            },
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            status: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            submitMode: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    StreamingText: {
        schema: {
            typeId: ComponentTypeID.StreamingText,
            description: 'Controlled progressively revealed assistant response text',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...MARGIN_UTILITY_PROPERTIES,
                size: enumProp(TEXT_SIZES, { default: 'md', description: 'Text size' }),
                weight: enumProp(TEXT_RECIPE_WEIGHTS, { default: 'normal', description: 'Font weight' }),
                color: enumProp(TEXT_RECIPE_COLORS, { default: 'default', description: 'Text color variant' }),
                align: enumProp(TEXT_ALIGNMENTS, { default: 'left', description: 'Text alignment' }),
                truncate: boolProp(false),
                uppercase: boolProp(false, { description: 'Transform text to uppercase' }),
                maxLines: numberProp({ description: 'Maximum visible lines before truncation' }),
                grow: numberProp({ description: 'Flex grow factor on text container' }),
                segments: arrayProp(objectProp({
                    text: stringProp({ required: true }),
                    kind: enumProp(STREAMING_TEXT_SEGMENT_KINDS, { default: 'text' }),
                    size: enumProp(TEXT_SIZES),
                    weight: enumProp(TEXT_RECIPE_WEIGHTS),
                    color: enumProp(TEXT_RECIPE_COLORS),
                    textStyle: stringProp(),
                }), { required: true, description: 'Styled source text segments controlled by the application.' }),
                revealedWordCount: numberProp({ required: true, description: 'Number of semantic words currently visible.' }),
                status: enumProp(STREAMING_TEXT_STATUSES, { default: 'complete', description: 'Whether the application is still streaming or has completed.' }),
                showCaret: boolProp(undefined, { description: 'Shows a presentation-only trailing caret.' }),
            }),
            slots: [],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'streaming-text',
                variants: STREAMING_TEXT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            segments: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            revealedWordCount: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            status: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            showCaret: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    MessagePair: {
        schema: {
            typeId: ComponentTypeID.MessagePair,
            description: 'Provider-agnostic user and assistant conversation turn',
            props: propsRecord({
                ...DIMENSION_UTILITY_PROPERTIES,
                ...MARGIN_UTILITY_PROPERTIES,
                user: contentProp({ required: true, description: 'Application-owned user message content.' }),
                assistant: contentProp({ required: true, description: 'Application-owned assistant response content.' }),
                actions: contentProp({ description: 'Optional visible application-owned assistant actions.' }),
                userVariant: enumProp(MESSAGE_PAIR_USER_VARIANTS, {
                    default: 'bubble',
                    description: 'Visual treatment for the user message.',
                }),
                userLabel: stringProp({ description: 'Accessible label for the user message region.' }),
                assistantLabel: stringProp({ description: 'Accessible label for the assistant response region.' }),
                actionsLabel: stringProp({ description: 'Accessible label for the assistant action group.' }),
            }),
            slots: slotsRecord({
                user: contentSlot({ required: true, description: 'Application-owned user message content.' }),
                assistant: contentSlot({ required: true, description: 'Application-owned assistant response content.' }),
                actions: contentSlot({ multiple: true, description: 'Optional visible application-owned assistant actions.' }),
            }),
            elements: ['user', 'assistant', 'actions'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'message-pair',
                variants: MESSAGE_PAIR_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            userVariant: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    ToolCall: {
        schema: {
            typeId: ComponentTypeID.ToolCall,
            description: 'Controlled provider-agnostic disclosure for one application-owned tool invocation',
            props: propsRecord({
                ...DIMENSION_UTILITY_PROPERTIES,
                ...MARGIN_UTILITY_PROPERTIES,
                label: contentProp({ required: true, description: 'Application-owned tool label.' }),
                activeLabel: contentProp({ description: 'Optional label shown while the tool is running.' }),
                icon: contentProp({ description: 'Optional decorative 16px icon shown before the tool label.' }),
                target: contentProp({ description: 'Optional compact target or query chip.' }),
                request: contentProp({ required: true, description: 'Application-owned request content shown while expanded.' }),
                result: contentProp({ description: 'Application-owned completed result shown only for completed state.' }),
                error: contentProp({ description: 'Application-owned failure content shown only for failed state.' }),
                state: enumProp(TOOL_CALL_STATES, { required: true, description: 'Application-owned state of this tool invocation.' }),
                open: boolProp(undefined, { required: true, description: 'Application-owned disclosure state.' }),
                disclosureIcon: contentProp({ description: 'Optional decorative disclosure icon.' }),
                statusIcon: contentProp({ description: 'Optional decorative state icon.' }),
                ariaLabel: stringProp({ description: 'Accessible label for the disclosure region.' }),
            }),
            slots: slotsRecord({
                label: contentSlot({ required: true, description: 'Application-owned tool label.' }),
                activeLabel: contentSlot({ description: 'Optional label shown while the tool is running.' }),
                icon: contentSlot({ description: 'Optional decorative 16px icon shown before the tool label.' }),
                target: contentSlot({ description: 'Optional compact target or query chip.' }),
                request: contentSlot({ required: true, description: 'Application-owned request content shown while expanded.' }),
                result: contentSlot({ description: 'Application-owned completed result shown only for completed state.' }),
                error: contentSlot({ description: 'Application-owned failure content shown only for failed state.' }),
            }),
            elements: ['label', 'activeLabel', 'icon', 'target', 'request', 'result', 'error'],
            events: ['openChange'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'tool-call',
                variants: TOOL_CALL_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            state: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            open: { scanner: { responsiveSupport: 'unsupported' } },
        },
    },
    Text: {
        schema: {
            typeId: ComponentTypeID.Text,
            description: 'Text element',
            props: propsRecord({
                ...VISIBILITY_UTILITY_PROPERTIES,
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...MARGIN_UTILITY_PROPERTIES,
                asChild: boolProp(false, { description: 'Merge this component into its single child node' }),
                size: enumProp(TEXT_SIZES, { default: 'md', description: 'Text size' }),
                weight: enumProp(TEXT_RECIPE_WEIGHTS, { default: 'normal', description: 'Font weight' }),
                color: enumProp(TEXT_RECIPE_COLORS, { default: 'default', description: 'Text color variant' }),
                align: enumProp(TEXT_ALIGNMENTS, { default: 'left', description: 'Text alignment' }),
                truncate: boolProp(false),
                uppercase: boolProp(false, { description: 'Transform text to uppercase' }),
                maxLines: numberProp({ description: 'Maximum visible lines before truncation' }),
                grow: numberProp({ description: 'Flex grow factor on text container' }),
            }),
            slots: ['children'],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'text',
                variants: TEXT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            ...VISIBILITY_PROP_GUARDRAILS,
            color: {
                scanner: {
                    detection: 'enum-or-extension-only',
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    TextInput: {
        schema: {
            id: 'Input',
            typeId: ComponentTypeID.Input,
            description: 'Text input',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                type: enumProp(INPUT_TYPES, { default: 'text' }),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                variant: enumProp(INPUT_VARIANTS, { default: 'outline' }),
                focusRing: enumProp(FOCUS_RING_PLACEMENTS, { description: 'Focus-ring placement for every focus interaction.' }),
                focusVisibleRing: enumProp(FOCUS_RING_PLACEMENTS, { description: 'Focus-ring placement when the browser considers focus visible.' }),
                value: stringProp(),
                placeholder: stringProp(),
                clearable: boolProp(false),
                clearLabel: stringProp({ description: 'Accessible label for the clear button' }),
                ariaActiveDescendant: stringProp({
                    description: 'Active descendant id for composite widgets that keep focus in the input.',
                }),
                name: stringProp(),
                min: stringProp({ description: 'Minimum value (number-like input types)' }),
                max: stringProp({ description: 'Maximum value (number-like input types)' }),
                step: stringProp({ description: 'Step value (number-like input types)' }),
                minLength: numberProp(),
                maxLength: numberProp(),
                grow: numberProp({ description: 'Flex grow factor' }),
                error: boolProp(false),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
            }),
            events: ['input', 'change', 'focus', 'blur'],
            slots: [],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'input',
                variants: INPUT_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            error: {
                scanner: {
                    responsiveSupport: 'unsupported',
                    variantProjection: {
                        axis: 'invalid',
                        valuesByInput: {
                            true: 'true',
                            false: 'false',
                        },
                    },
                },
            },
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
    Textarea: {
        schema: {
            typeId: ComponentTypeID.Textarea,
            description: 'Multi-line text input',
            props: propsRecord({
                ...TEXT_STYLE_UTILITY_PROPERTY,
                ...DIMENSION_UTILITY_PROPERTIES,
                name: stringProp(),
                value: stringProp(),
                placeholder: stringProp(),
                size: enumProp(CONTROL_SIZES, { default: 'md' }),
                variant: enumProp(INPUT_VARIANTS, { default: 'filled' }),
                focusRing: enumProp(FOCUS_RING_PLACEMENTS, { description: 'Focus-ring placement for every focus interaction.' }),
                focusVisibleRing: enumProp(FOCUS_RING_PLACEMENTS, { description: 'Focus-ring placement when the browser considers focus visible.' }),
                resize: enumProp(TEXTAREA_RESIZES, { default: 'vertical' }),
                clearable: boolProp(false),
                clearLabel: stringProp({ description: 'Accessible label for the clear button' }),
                autoresize: boolProp(false),
                minLength: numberProp(),
                maxLength: numberProp(),
                error: boolProp(false),
                invalid: boolProp(false),
                disabled: boolProp(false),
                readOnly: boolProp(false),
                required: boolProp(false),
            }),
            events: ['input', 'change', 'focus', 'blur'],
            slots: [],
        },
        styling: {
            support: 'recipe-backed',
            recipe: {
                name: 'textarea',
                variants: TEXTAREA_RECIPE_VARIANTS,
            },
        },
        propGuardrails: {
            disabled: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
            error: {
                scanner: {
                    responsiveSupport: 'unsupported',
                    variantProjection: {
                        axis: 'invalid',
                        valuesByInput: {
                            true: 'true',
                            false: 'false',
                        },
                    },
                },
            },
            invalid: {
                scanner: {
                    responsiveSupport: 'unsupported',
                },
            },
        },
    },
});
export const BUILT_IN_COMPONENT_IDS = Object.freeze(Object.keys(BUILT_IN_COMPONENT_REGISTRY).sort(compareStrings));
export const BUILT_IN_COMPONENT_SCHEMA_ID_BY_COMPONENT = Object.freeze(Object.fromEntries(BUILT_IN_COMPONENT_IDS.map((componentId) => [
    componentId,
    BUILT_IN_COMPONENT_REGISTRY[componentId].schema.id ?? componentId,
])));
export const BUILT_IN_COMPONENT_ID_BY_SCHEMA_ID = Object.freeze(Object.fromEntries(BUILT_IN_COMPONENT_IDS.map((componentId) => [
    BUILT_IN_COMPONENT_SCHEMA_ID_BY_COMPONENT[componentId],
    componentId,
])));
//# sourceMappingURL=built-in-component-registry.js.map